import { convertAQLToDashboardCardFilters } from './aqlToDashboardCardFilters'
import { convertDashboardCardDefToDashboardCardFormatFields } from './dashboardCardDefToDashboardCardFormatFields'
import { convertDashboardCardDefToWorkflows } from './dashboardCardDefToWorkflows'
import type { DashboardCardDef } from '@edge/spark/io-dashboards'
import type { DashboardCardConfig } from '../types'

/**
 * Converts a widgetDef (DashboardCardDef) to the form values (DashboardCardConfig)
 * Used for initial render */
export const convertDashboardCardDefToDashboardCardConfig = (
    widgetDef: DashboardCardDef,
    readOnly?: boolean,
): DashboardCardConfig => {
    const type = readOnly ? 'STATIC' : widgetDef.config?.contactLogSearch ? 'CONTACT_LOG' : 'SEARCH'
    const aql =
        (type === 'CONTACT_LOG'
            ? widgetDef.config?.contactLogSearch?.searchString
            : widgetDef.config?.search?.searchString) || ''
    const format = convertDashboardCardDefToDashboardCardFormatFields(widgetDef)
    const filters = convertAQLToDashboardCardFilters(aql)
    const workflows = convertDashboardCardDefToWorkflows(widgetDef)

    return { format, type, aql, filters, workflows }
}

export default convertDashboardCardDefToDashboardCardConfig
